import { Route, Routes } from "react-router-dom";
import SinglesSchoolCard from "./pages/SinglesSchoolCard";
import TransactionModeWise from "./pages/TransactionModeWise";
import Transaction from "./pages/Transaction";
import StudentList from "./pages/StudentList";
import EditSchoolDetails from "./pages/EditSchoolDetails";
import SchoolList from "./pages/SchoolList";
// export const getSchool = async () => {
//   var myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//   myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"))

//   var requestOptions: RequestInit = {
//     method: "GET",
//     headers: myHeaders,
//     redirect: "follow"
//   }
//   return await (await fetch(process.env.REACT_APP_BACKEND_URL + "/api/school/all-schools", requestOptions)).json()
// }
function SchoolProfile() {
  // const [get_school, set_get_school] = React.useState([])
  // const { schools, set_schools } = useContext(dashboardContext);

  return (
    <div className="flex flex-col flex-1 w-full bg-white ">
      <Routes>
        <Route path="/" element={<SchoolList />} />
        <Route path="/:id/*" element={<SinglesSchoolCard />} />
        <Route path="/:id/edit*" element={<EditSchoolDetails />} />
        <Route path="/:id/transaction/*" element={<Transaction />} />
        <Route
          path="/:id/transaction-mode-wise/*"
          element={<TransactionModeWise />}
        />
        <Route path="/:id/:name/student-list/*" element={<StudentList />} />
      </Routes>
    </div>
  );
}

export default SchoolProfile;
